import { render, staticRenderFns } from "./AgentPage.vue?vue&type=template&id=68e4b51f&scoped=true"
import script from "./AgentPage.vue?vue&type=script&lang=js"
export * from "./AgentPage.vue?vue&type=script&lang=js"
import style0 from "./AgentPage.vue?vue&type=style&index=0&id=68e4b51f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e4b51f",
  null
  
)

export default component.exports